import { FlashMessageActions } from './flashMessage.enum';
import { RemoveFlashMessageAction, SetFlashMessageAction, SetFlashMessagePayload } from './flashMessage.interface';

let id = 0;

export function setFlashMessage(flashMessage: Omit<SetFlashMessagePayload, 'id'>): SetFlashMessageAction {
  id++;

  return {
    flashMessage: {
      ...flashMessage,
      id: id,
      shouldDisableAutoHide: flashMessage.shouldDisableAutoHide || false,
    },
    type: FlashMessageActions.SET_FLASH_MESSAGE,
  };
}

export function setSuccessFlashMessage(message: string, shouldDisableAutoHide = false): SetFlashMessageAction {
  return setFlashMessage({
    shouldDisableAutoHide: shouldDisableAutoHide,
    title: message,
    type: 'success',
  });
}

export function setErrorFlashMessage(message?: string, shouldDisableAutoHide = false): SetFlashMessageAction {
  return setFlashMessage({
    shouldDisableAutoHide: shouldDisableAutoHide,
    title: message || 'Sorry, something went wrong',
    type: 'error',
  });
}

export function removeFlashMessage(id: number): RemoveFlashMessageAction {
  return {
    id: id,
    type: FlashMessageActions.REMOVE_FLASH_MESSAGE,
  };
}
